module.exports = __webpack_public_path__ + "img/social_facebook.ee9327ad.svg";